/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { getEntities as getOrganisms } from 'app/entities/organism/organism.reducer';
import { getEntities as getAntibiotics } from 'app/entities/antibiotic/antibiotic.reducer';
import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { createEntity, getEntity, reset, updateEntity } from './lab-test-item-organism-antibiotic.reducer';

export const LabTestItemOrganismAntibioticUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const organisms = useAppSelector(state => state.organism.entities);
  const antibiotics = useAppSelector(state => state.antibiotic.entities);
  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const labTestItemOrganismAntibioticEntity = useAppSelector(state => state.labTestItemOrganismAntibiotic.entity);
  const loading = useAppSelector(state => state.labTestItemOrganismAntibiotic.loading);
  const updating = useAppSelector(state => state.labTestItemOrganismAntibiotic.updating);
  const updateSuccess = useAppSelector(state => state.labTestItemOrganismAntibiotic.updateSuccess);

  const handleClose = () => {
    navigate(`/lab-test-item-organism-antibiotic${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getLabTestItems({}));
    dispatch(getOrganisms({}));
    dispatch(getAntibiotics({}));
    dispatch(getDiagLabs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.micSusceptible !== undefined && typeof values.micSusceptible !== 'number') {
      values.micSusceptible = Number(values.micSusceptible);
    }
    if (values.micIntermediate !== undefined && typeof values.micIntermediate !== 'number') {
      values.micIntermediate = Number(values.micIntermediate);
    }
    if (values.micResistant !== undefined && typeof values.micResistant !== 'number') {
      values.micResistant = Number(values.micResistant);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...labTestItemOrganismAntibioticEntity,
      ...values,
      source: clinicalDictionaries.find(it => it.id.toString() === values.source?.toString()),
      labTestItem: labTestItems.find(it => it.id.toString() === values.labTestItem?.toString()),
      organism: organisms.find(it => it.id.toString() === values.organism?.toString()),
      antibiotic: antibiotics.find(it => it.id.toString() === values.antibiotic?.toString()),
      lab: diagLabs.find(it => it.id.toString() === values.lab?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...labTestItemOrganismAntibioticEntity,
          source: labTestItemOrganismAntibioticEntity?.source?.id,
          labTestItem: labTestItemOrganismAntibioticEntity?.labTestItem?.id,
          organism: labTestItemOrganismAntibioticEntity?.organism?.id,
          antibiotic: labTestItemOrganismAntibioticEntity?.antibiotic?.id,
          lab: labTestItemOrganismAntibioticEntity?.lab?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.labTestItemOrganismAntibiotic.home.createOrEditLabel"
            data-cy="LabTestItemOrganismAntibioticCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.home.createOrEditLabel">
              Create or edit a LabTestItemOrganismAntibiotic
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="lab-test-item-organism-antibiotic-id"
                  label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.suggestedBy')}
                id="lab-test-item-organism-antibiotic-suggestedBy"
                name="suggestedBy"
                data-cy="suggestedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.micSusceptible')}
                id="lab-test-item-organism-antibiotic-micSusceptible"
                name="micSusceptible"
                data-cy="micSusceptible"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.micIntermediate')}
                id="lab-test-item-organism-antibiotic-micIntermediate"
                name="micIntermediate"
                data-cy="micIntermediate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.micResistant')}
                id="lab-test-item-organism-antibiotic-micResistant"
                name="micResistant"
                data-cy="micResistant"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.notes')}
                id="lab-test-item-organism-antibiotic-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.active')}
                id="lab-test-item-organism-antibiotic-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.cursor')}
                id="lab-test-item-organism-antibiotic-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.lastUpdated')}
                id="lab-test-item-organism-antibiotic-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.microSec')}
                id="lab-test-item-organism-antibiotic-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.timestampEntry')}
                id="lab-test-item-organism-antibiotic-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="lab-test-item-organism-antibiotic-source"
                name="source"
                data-cy="source"
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.source')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-organism-antibiotic-labTestItem"
                name="labTestItem"
                data-cy="labTestItem"
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.labTestItem')}
                type="select"
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-organism-antibiotic-organism"
                name="organism"
                data-cy="organism"
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.organism')}
                type="select"
              >
                <option value="" key="0" />
                {organisms
                  ? organisms.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-organism-antibiotic-antibiotic"
                name="antibiotic"
                data-cy="antibiotic"
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.antibiotic')}
                type="select"
              >
                <option value="" key="0" />
                {antibiotics
                  ? antibiotics.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-organism-antibiotic-lab"
                name="lab"
                data-cy="lab"
                label={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.lab')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/lab-test-item-organism-antibiotic"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LabTestItemOrganismAntibioticUpdate;
